class TermsCheckbox {
  constructor(wrapper) {
    this.wrapper = wrapper;
    this.checkbox = wrapper.querySelector('.js-terms-checkbox');
    this.error = wrapper.querySelector('.js-terms-error');

    if (!this.checkbox) return;

    this.bindEvents();
    setTimeout(() => {
      this.updateButtonsState();
    }, 150);
  }

  // --- Select all relevant buttons ---
  getButtons() {
    return document.querySelectorAll(`
      button[name="checkout"],
      .shopify-payment-button button,
      shopify-buy-it-now-button button
    `);
  }

  // --- Enable/Disable buttons ---
  updateButtonsState() {
    const disabled = !this.checkbox.checked;

    this.getButtons().forEach((btn) => {
      if (disabled) {
        btn.classList.add('terms-disabled');
        btn.setAttribute('disabled', 'disabled');
        btn.setAttribute('aria-disabled', 'true');
      } else {
        btn.classList.remove('terms-disabled');
        btn.removeAttribute('disabled');
        btn.removeAttribute('aria-disabled');
      }
    });
  }

  // --- Show error ---
  showError() {
    if (this.error) {
      this.error.hidden = false;
    }

    this.checkbox.scrollIntoView({
      behavior: 'smooth',
      block: 'center'
    });

    this.checkbox.focus();
  }

  // --- Hide error ---
  clearError() {
    if (this.error) {
      this.error.hidden = true;
    }
  }

  // --- Bind events ---
  bindEvents() {
    // Checkbox change
    this.checkbox.addEventListener('change', () => {
      this.updateButtonsState();

      if (this.checkbox.checked) {
        this.clearError();
      }
    });

    // Global click handler
    document.addEventListener('click', (e) => {
      const btn = e.target.closest(`
        button[name="checkout"],
        .shopify-payment-button button,
        shopify-buy-it-now-button button
      `);

      if (!btn) return;

      if (!this.checkbox.checked) {
        e.preventDefault();
        e.stopImmediatePropagation(); // VERY IMPORTANT

        this.showError();
      }
    });
  }
}


// --- INIT FUNCTION ---
function initTermsCheckbox(scope = document) {
  const wrappers = scope.querySelectorAll(
    '.terms-wrapper[data-terms-enabled="true"]'
  );

  wrappers.forEach((wrapper) => {
    if (wrapper.dataset.termsInit) return;

    wrapper.dataset.termsInit = 'true';
    new TermsCheckbox(wrapper);
  });
}


// --- INIT EVENTS ---
document.addEventListener('DOMContentLoaded', () => {
  initTermsCheckbox();
});

// Shopify section reload (Dawn)
document.addEventListener('shopify:section:load', (e) => {
  initTermsCheckbox(e.target);
});

// MutationObserver (Buy Now + Cart Drawer)
const observer = new MutationObserver(() => {
  initTermsCheckbox();
});

observer.observe(document.body, {
  childList: true,
  subtree: true
});